export default [
  'M-14-10h40v40h-40z',
  'M12.32 2.333L9.99 0 0 10l9.99 10 2.33-2.333L4.662 10z',
];
